if (!customElements.get('size-guide-page')) {
  class SizeGuidePage extends HTMLElement {
    constructor() {
      super();
      this.handleGenderTabClick = this.handleGenderTabClick.bind(this);
    }

    connectedCallback() {
      this.tableRoots = Array.from(this.querySelectorAll('[data-size-table]'));
      this.genderTabs = Array.from(this.querySelectorAll('[data-gender-target]'));
      this.genderPanels = Array.from(this.querySelectorAll('[data-gender-panel]'));

      this.tableRoots.forEach((root) => this.enhanceTable(root));
      this.genderTabs.forEach((tab) => tab.addEventListener('click', this.handleGenderTabClick));
    }

    disconnectedCallback() {
      this.genderTabs.forEach((tab) => tab.removeEventListener('click', this.handleGenderTabClick));
    }

    handleGenderTabClick(e) {
      const target = e.currentTarget.dataset.genderTarget;
      this.genderTabs.forEach((tab) => {
        const isActive = tab.dataset.genderTarget === target;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.genderPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.genderPanel === target);
      });
    }

    enhanceTable(tableRoot) {
      const table = tableRoot.querySelector('table');
      if (!table) return;

      const firstRow = table.querySelector('tr');
      if (firstRow && !table.tHead) {
        const thead = document.createElement('thead');
        thead.appendChild(firstRow.cloneNode(true));
        table.insertBefore(thead, table.firstChild);
        firstRow.remove();
        const cells = thead.querySelectorAll('td');
        cells.forEach((td) => {
          const th = document.createElement('th');
          th.innerHTML = td.innerHTML;
          td.replaceWith(th);
        });
      }
    }
  }

  customElements.define('size-guide-page', SizeGuidePage);
}
